import {getTrackingValues, getValueFromBrowser, setValueToBrowser} from "./trackingQueryHook";
import {initializeSession, redirectAfterRegistration} from "./session";
import {loginRegistrationAdditionalHeaders, loginWithEmail} from "./utils";
import {EMAIL_REG_EXP, GtagEventNames} from "./consts";
import {disableSubmitButton} from "../js/popups/activate_forms";
import {APP_SERVER_URL} from "../../../config";
import {internalSetCookie} from "./cookies";
import { trackGtagEvent } from "./utils.js";
import { closeAllPopups, openPopupById } from './togglePopup';

const MAX_ERROR_COUNT = 2;
let errorCount = 0;

export const login = (data) => {
    const loginSubmitButton = document.getElementById('login-form-submit-button');

    if (loginSubmitButton?.disabled === false) {
        disableSubmitButton(loginSubmitButton, true);
        const userNameEmail = loginWithEmail() ? data?.target[0]?.value : getValueFromBrowser('email');
        const password = data?.target[1]?.value;
        const remember = data?.target[3]?.checked;
        const affiliateInformation = getTrackingValues();
        const emailErrorSpan = document.getElementById('login-form-password-email-span');
        const passwordErrorSpan = document.getElementById('login-form-password-password-span');
        const errorMessageCredentials = document.getElementById('login-form-password-credentails-span');

        const requestData = userNameEmail.match(EMAIL_REG_EXP)
            ? {
                email: userNameEmail.trim(),
                password,
                remember,
                affiliateInformation
            }
            : {
                nickName: userNameEmail.trim(),
                password,
                remember,
                affiliateInformation
            };

        fetch(`${APP_SERVER_URL}player/crm/login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...loginRegistrationAdditionalHeaders()
            },
            body: JSON.stringify(requestData)
        })
            .then((response) => {
                if (!response.ok) {
                    // If response is not ok, parse the response to get the error details
                    return response.json().then(error => {
                        return Promise.reject(error);
                    });
                }
                return response.json();
            })
            .then((response) => {
                initializeSession(response);
                localStorage.setItem(
                    'rememberUser',
                    requestData.remember ? 'remember' : 'not_remember'
                );
                setValueToBrowser('email', response?.email);
                localStorage.setItem('userId', response?.id);
                localStorage.setItem('firstName', response?.firstName);
                setValueToBrowser('product', response?.product?.toString());
                internalSetCookie('userHasAccount', 'true');
                setValueToBrowser('loginWithEmail', 'false');
                if (response?.affiliateId) {
                    setValueToBrowser("affiliateId", response.affiliateId);
                }
                if (response?.sourceId) {
                    setValueToBrowser("sourceId", response.sourceId);
                }
                trackGtagEvent(GtagEventNames.LOGIN_SUCCESS);
                redirectAfterRegistration();
            })
            .catch((e) => {
                const {message} = e;
                switch (message) {
                    case 'account.status.is':
                        alert('El estado de la cuenta es no está activo.');
                        break;
                    case 'empty.email.nickname':
                        if (emailErrorSpan) {
                            emailErrorSpan.innerHTML = 'Correo electrónico y nombre de usuario vacíos';
                        }
                        break;
                    case 'empty.password':
                        if (passwordErrorSpan) {
                            passwordErrorSpan.innerHTML = 'Correo electrónico y nombre de usuario vacíos';
                        }
                        break;
                    case 'incorrect.credentials':
                        if (errorMessageCredentials) {
                            errorMessageCredentials.innerHTML = 'El nombre de usuario/correo electrónico o la contraseña son incorrectos';
                        }
                        break;
                    default :
                        if (errorMessageCredentials) {
                            errorMessageCredentials.innerHTML = 'Hay problemas con su cuenta. Por favor contacte al soporte.';
                        }
                        break;
                }
                trackGtagEvent(GtagEventNames.LOGIN_FAILURE);

                errorCount++;
                if (errorCount >= MAX_ERROR_COUNT) {
                    errorCount = 0;
                    closeAllPopups();
                    openPopupById("ForgotPassword");
                }
            })
            .finally(() => {
                disableSubmitButton(loginSubmitButton, false);
            });
    }
}
